// this needs to reflect the height of the header (in `src/styles/variables.scss -> $headerHeight)
export const headerHeight = 90;
